module.exports = __webpack_public_path__ + "img/arrow-narrow-left.a94dc3f2.svg";